import { forwardRef } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import {
  resolveBaseAppearance,
  resolveBaseLayoutAlign,
  resolveBaseLayoutJustify,
  resolveBaseLayoutLength,
} from './theme';
import type { BaseStackProps } from './types';
import { cn } from './utils';

export const BaseStack = forwardRef<HTMLDivElement, BaseStackProps>(
  function BaseStack(
    {
      children,
      gap,
      align = 'stretch',
      justify = 'start',
      appearance,
      className,
      classNames,
      style,
      ...stackProps
    },
    ref,
  ) {
    const resolvedAppearance = useMonkeysBaseAppearance(appearance);
    const componentAttributes = useMonkeysComponentAttributes();
    const theme = resolveBaseAppearance(resolvedAppearance);
    const resolvedGap =
      gap === undefined
        ? undefined
        : resolveBaseLayoutLength('BaseStack', 'gap', gap);

    return (
      <div
        {...componentAttributes}
        {...stackProps}
        ref={ref}
        data-monkeys-component="stack"
        data-slot="root"
        data-align={align}
        data-justify={justify}
        className={cn(theme.slots.stackRoot, classNames?.root, className)}
        style={{
          ...theme.styles.stack,
          gap: resolvedGap,
          alignItems: resolveBaseLayoutAlign('BaseStack', align),
          justifyContent: resolveBaseLayoutJustify('BaseStack', justify),
          ...style,
        }}
      >
        {children}
      </div>
    );
  },
);
